/**
 * @constant 
 * @description this variable represents 1 minute
 */
export const TIMEOUT_IN_MILLISECONDS = 60000;

/**
 * @constant 
 * @description this variable represents 5 minute
 */
export const TIMEOUT_5_MINUTES_MS = 5 * 60 * 1000;

/**
 * @constant 
 * @description this variable represents indefinite period of time
 */
export const TIMEOUT_INFINITE = 0;